import React, { useState, useEffect } from "react";
import Layout from "../components/Layout";
import PersonaSelect from "../components/PersonaSelect";
import { api } from "../lib/api";

function Stat({ label, value, tone }) {
  return (
    <div className="rounded-lg border border-neutral-800 bg-neutral-900/50 p-4">
      <div className="text-xs text-neutral-500">{label}</div>
      <div className={"text-2xl font-bold mt-1 " + (tone || "")}>{value}</div>
    </div>
  );
}

export default function Performance() {
  const [pid, setPid] = useState("");
  const [camps, setCamps] = useState([]);
  const [planId, setPlanId] = useState("");
  const [metric, setMetric] = useState(null);
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState("");

  useEffect(() => {
    if (!pid) { setCamps([]); setPlanId(""); setMetric(null); return; }
    api.listCampaigns(pid).then((c) => { setCamps(c); setPlanId(c[0]?.id || ""); }).catch((e) => setErr(String(e.message)));
  }, [pid]);

  useEffect(() => {
    if (!planId) { setMetric(null); return; }
    api.listPerformance(planId).then((m) => setMetric(m[0] || null)).catch(() => {});
  }, [planId]);

  const project = async () => {
    setBusy(true); setErr("");
    try { setMetric(await api.recordPerformance(planId, {})); }
    catch (e) { setErr(String(e.message)); } finally { setBusy(false); }
  };

  return (
    <Layout>
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-2xl font-bold">Performance</h1>
          <p className="text-neutral-400 text-sm mt-1">CAC, ROI, visitas e recomendações de redistribuição de verba.</p>
        </div>
        <PersonaSelect value={pid} onChange={setPid} />
      </div>
      {err && <div className="mt-4 rounded-md bg-red-600/15 text-red-400 px-4 py-2 text-sm">{err}</div>}
      {camps.length > 0 && (
        <div className="mt-4 flex items-center gap-3">
          <select value={planId} onChange={(e) => setPlanId(e.target.value)}
            className="rounded-md bg-neutral-800 border border-neutral-700 px-3 py-2 text-sm max-w-md">
            {camps.map((c) => <option key={c.id} value={c.id}>{(c.objective || c.id).slice(0, 60)}</option>)}
          </select>
          <button onClick={project} disabled={busy || !planId}
            className="rounded-md bg-red-600 hover:bg-red-500 px-4 py-2 text-sm font-medium disabled:opacity-50">
            {busy ? "Calculando…" : "Projetar performance"}
          </button>
        </div>
      )}
      {metric && (
        <>
          <div className="mt-6 grid grid-cols-2 md:grid-cols-5 gap-3">
            <Stat label="Leads" value={metric.leads} />
            <Stat label="Visitas est." value={metric.estimated_visits} />
            <Stat label="Conversões" value={metric.conversions} />
            <Stat label="CAC" value={metric.cac != null ? `R$${metric.cac}` : "—"} tone="text-amber-400" />
            <Stat label="ROI" value={metric.roi != null ? `${metric.roi}x` : "—"} tone="text-emerald-400" />
          </div>
          {metric.optimization_recommendations?.length > 0 && (
            <div className="mt-6 rounded-lg border border-neutral-800 bg-neutral-900/50 p-4">
              <div className="text-sm font-medium mb-2">Recomendações de otimização</div>
              <ul className="text-xs text-neutral-300 list-disc pl-4 space-y-1">
                {metric.optimization_recommendations.map((r, i) => <li key={i}>{r}</li>)}
              </ul>
              {metric.best_zones?.length > 0 && <div className="text-xs text-neutral-500 mt-3">Melhores zonas: {metric.best_zones.join(", ")}</div>}
            </div>
          )}
        </>
      )}
      {pid && !camps.length && <div className="mt-6 text-neutral-500 text-sm">Sem campanhas pra medir. Gere uma campanha primeiro.</div>}
    </Layout>
  );
}
